import React from 'react'
import { Text, View } from 'react-native'
import { HelpButton } from '../../ui/HelpButton'
import { InfoModal } from '../../ui/InfoModal'
import { WARFISH_CLASSICS_EXPLANATION, WARFISH_CLASSICS_HELP_LABEL, WARFISH_CLASSICS_LONG_FORM } from './presentation'

/** The Warfish.net classics explainer. Opened by the help button and by the board's logo. */
export function WarfishClassicsAboutModal({ visible, onClose }: { visible: boolean; onClose: () => void }) {
  return <InfoModal visible={visible} onClose={onClose} title={WARFISH_CLASSICS_LONG_FORM}
    variant="help" closeLabel="Close Warfish.net classic boards help" testID="warfish-classics-about"
    message={WARFISH_CLASSICS_EXPLANATION} />
}

/** One explainer shared by map config, picker sections and the gallery. */
export function WarfishClassicsHelp({ testID = 'warfish-classics-help' }: { testID?: string }) {
  const [visible, setVisible] = React.useState(false)
  return <>
    <HelpButton testID={testID} size={28} onPress={() => setVisible(true)} accessibilityLabel={WARFISH_CLASSICS_HELP_LABEL} />
    <WarfishClassicsAboutModal visible={visible} onClose={() => setVisible(false)} />
  </>
}

export function WarfishClassicsSectionHeader({ helpTestID }: { helpTestID: string }) {
  return <View className="flex-row items-center gap-2">
    <Text accessibilityRole="header" className="font-stencil text-[10px] uppercase tracking-widest text-olive-up">
      {WARFISH_CLASSICS_LONG_FORM}
    </Text>
    <WarfishClassicsHelp testID={helpTestID} />
  </View>
}
